
import { CartGradeOptionDiscountUrl } from "../directives/utilities/urls";
export default function feeSummary() {
    return {
        selectedSubjectFilter: document.getElementById("categoryId")?.value || [],
        showErrorMesage: "",
        showSuccessMesage: "",
        lineItems: [],
        hasMore: false,
        showLoader: false,
        total_Amount: '0',
        total_discount:'0',
        messages: '',
        backUrl: CartGradeOptionDiscountUrl,
        formatDate(dateValue) {
            const options = { month: "short", day: "numeric" };
            const formattedDate = new Date(dateValue).toLocaleDateString(
                undefined,
                options
            );
            return formattedDate;
        },
   
        removeCartList(item) {
            if (confirm("Are you sure to remove this course from your cart?")) {
                var jsonData = JSON.stringify({
                    "UserSessionId": "",
                    "AcademicYear": item.academicYear,
                    "AcademicTerm": item.academicTerm,
                    "AcademicSession": item.academicSession,
                    "SerialId": item.serialId
                });
                this.showLoader = true;

                fetch("/api/Checkout/delete-course-from-cart", {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: jsonData,
                })
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        this.showLoader = false;
                        if (response != undefined && response.isSuccess) {
                            this.showSuccessMesage = "Course removed succesfully."
                            this.bindCartList();
                        } else {
                            this.showErrorMesage = "An unknown error has occurred. Please try again later.";
                        }
                    });
            }

        },
        btnCancelClick() {
                document.location.href = '/api/login/SignOut';        
        },
        bindAssessCart() {
            fetch('/api/Checkout/assess-cart', { "method": "GET" })
                .then(response => {
                    return response.json();
                }).then(login => {

                })
        },
        bindCartList() {
            var jsonData = JSON.stringify({
                SessionId: "",
                CartRequestType: "A"
            });
            this.showLoader = true;
            this.waitlistCartList = [];
            this.enrollmentCartList = [];
            fetch("/api/Checkout/fee-summary", {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }
            })
                .then((response) => {
                   
                    return response.json();
                })
                .then((response) => {
                    this.showLoader = false;
                    this.backUrl = response.backUrl;
                    if (response != undefined && response.isSuccess) {

                        if (response.lineItems.length > 0) {
                         
                            this.total_Amount = response.lineItems.reduce((sum, item) => sum += item.fee, 0);
                            //this.total_discount = response.lineItems.filter(x => x.chargeCreditType == "D").reduce((sum, item) => sum += item.fee, 0);
                            //if (this.total_Amount > 0)
                            //    this.total_discount = Math.abs(this.total_discount);
                            Array.prototype.push.apply(this.lineItems, response.lineItems);
                        } else {
                            this.showErrorMesage = "Your cart is empty.";
                        }
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later.";
                    }
                });
        },
        init() {
            //this.bindAssessCart();
            this.bindCartList();
        },
    };
}
